import { useLanguage } from "@/contexts/LanguageContext";
import { AboutPage } from "@/components/partners/PartnerSections";

/**
 * "Über uns" — the website draft's 3g screen. The nav's Über uns entry points
 * here; the page previously held the older "Co-Living. Neu gedacht." concept
 * pitch, which the draft replaces with the founders' story.
 */
const Concept = () => {
  const { language } = useLanguage();
  return <AboutPage de={language === "de"} />;
};

export default Concept;
